// components
import PublicProfile from 'src/pages/jobster/profile'

const FreelancerProfile = () => {
  return <PublicProfile />
}

export default FreelancerProfile
